import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const PATHS = [
  {
    testid: "path-b2c",
    clip: "/assets/braced-no-more.mp4",
    eyebrow: "For individuals & families seeking relief",
    title: "Personal Healing & Somatic Recovery",
    desc: "Chronic stress, anxiety, and unresolved trauma keep your body braced long after the danger has passed. Through “Braced No More,” step into a safe, guided space that quiets the mental static, regulates your nervous system, and helps you live in your authentic cadence again.",
    cta: "Enter Braced No More",
    href: "https://bracednomore.online",
  },
  {
    testid: "path-b2b",
    clip: "/assets/door-rhythm-bg.mp4",
    eyebrow: "For clinics, nonprofits, schools & corporate teams",
    title: "Organizations, Teams & Communities",
    desc: "Bring bilateral-rhythm frameworks to your staff, clients, students, or leadership. Reduce burnout, deepen engagement, and rebuild connection through high-impact keynotes, forte-building workshops, and clinical music programs designed for the people you serve.",
    cta: "Explore Casey Muze for Organizations",
    href: "https://caseymuze.info",
  },
];

const Card = ({ path, index }) => (
  <motion.a
    href={path.href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={path.testid}
    data-cursor="org"
    className="group relative flex min-h-[440px] flex-col justify-end overflow-hidden rounded-3xl border border-[#AEE6D5]/15 p-8 sm:p-10 lg:min-h-[520px]"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
  >
    <video
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
      src={path.clip}
      muted loop autoPlay playsInline preload="none"
    />
    <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(10,46,44,0.55) 0%, rgba(10,46,44,0.7) 55%, rgba(10,46,44,0.96) 100%)" }} />

    <div className="relative z-10">
      <p className="font-mono text-[0.62rem] uppercase tracking-[0.24em] text-[#AEE6D5]">{path.eyebrow}</p>
      <h3 className="mt-4 font-serif text-3xl font-light leading-[1.08] tracking-tight text-[#F8FAFC] sm:text-4xl">
        {path.title}
      </h3>
      <p className="mt-5 max-w-md text-sm leading-relaxed text-[#F8FAFC]/75">{path.desc}</p>
      <span className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-bold text-[#0A2E2C] transition-colors group-hover:bg-[#B99628]">
        {path.cta}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </motion.a>
);

export const DualPaths = () => (
  <section className="relative z-10 bg-[#0A2E2C] px-6 py-20 sm:px-10 lg:px-12 lg:py-32" data-testid="dual-paths">
    <div className="mx-auto max-w-6xl">
      <div className="mb-14 text-center">
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.3em] text-[#D4AF37]">Finding your cadence</p>
        <h2 className="mt-4 font-serif text-4xl font-light tracking-tight text-[#F8FAFC] sm:text-5xl">
          Two paths back to <span className="italic text-[#AEE6D5]">rhythm.</span>
        </h2>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        {PATHS.map((p, i) => <Card key={p.testid} path={p} index={i} />)}
      </div>
    </div>
  </section>
);
